import { useTranslation } from 'react-i18next';
import { shortName } from '../../utils/tripLegs';
import { Icon, Globe } from '../ui/Icon';

interface Props {
  legs: readonly { name: string }[];
  /** Index into `legs`; null = no leg picked. */
  active: number | null;
  /** Picking the active leg again goes back to the whole trip. */
  onSelect: (legIdx: number) => void;
}

/** ADR-0030: one chip per destination, at the head of a map filter bar. Nothing with a single one. */
export default function LegChips({ legs, active, onSelect }: Props) {
  const { t } = useTranslation();
  if (legs.length < 2) return null;

  return (
    <>
      {legs.map((leg, i) => {
        const on = active === i;
        return (
          <button
            key={`${i}-${leg.name}`}
            onClick={() => onSelect(i)}
            aria-pressed={on}
            title={on ? t('map.destinationChip.showWholeTrip') : t('map.destinationChip.showOnly', { name: shortName(leg.name) })}
            className={`flex items-center gap-1.5 shrink-0 px-2.5 py-1 rounded-full border text-xs font-medium transition-all cursor-pointer select-none ${
              on
                ? 'border-transparent bg-teal-600 text-white shadow-sm'
                : 'border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800'
            }`}
          >
            <Icon as={Globe} size={12} />
            {shortName(leg.name)}
          </button>
        );
      })}
      <span className="w-px h-5 bg-slate-200 dark:bg-slate-700 shrink-0" aria-hidden />
    </>
  );
}
